// shadcn/ui Badge, on the HPG tokens.
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export const badgeVariants = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium [&_svg]:size-3',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-on-primary',
        outline: 'border-border-strong text-text',
        muted: 'border-transparent bg-surface text-muted',
        danger: 'border-danger text-danger',
        warning: 'border-warning text-warning',
        success: 'border-success text-success',
        info: 'border-info text-info',
      },
    },
    defaultVariants: { variant: 'outline' },
  },
);

export interface BadgeProps extends ComponentProps<'span'>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
